import { orange } from '@mui/material/colors';

export const NO_WORKABLE_ENCOUNTERS = -1;
export const ALL_ENCOUNTERS_LOCKED = -2;

/* LOCAL CONSTANTS */
const ORANGE_VALUE = 600;
const GRID_ROW_XS_OFFSET = 1;
const GRID_ROW_FULL_WIDTH_ROW_SIZE = 12;
const GRID_KPI_INDICATOR_XS = 2.5;

/* THEME & COLORS */
export const THEME_PRIMARY_COLOR = '#303f9f';
export const { [ORANGE_VALUE]: THEME_SECONDARY_COLOR } = orange;
export const FONT_WEIGHT_700 = 700;

/* GRID & LAYOUT */
export const GRID_SPACING = 2;
export const GRID_ROW_FULL_WIDTH_ROW = { xs: GRID_ROW_FULL_WIDTH_ROW_SIZE };
export const GRID_ROW_NEW_LINE_OFFSET = { xs: GRID_ROW_XS_OFFSET };
export const GRID_ROW_KPI_INDICATOR_SIZE = { xs: GRID_KPI_INDICATOR_XS };

/* KPI INDICATOR INFO STRINGS */
export const INFO_COUNT_OF_INCOMPLETE_ENCOUNTER_REVIEWS = `This number is a count
  of encounters that have reviews which are not marked as completed. An
  encounter's review can be completed by accepting or rejecting all of the
  encounter's line items followed by clicking the "complete" button and
  confirming the completion in the dialog.`;

export const INFO_COUNT_OF_COMPLETED_ENCOUNTER_REVIEWS = `This number is a count
  of encounters that have reviews which are marked as completed. These encounters
  either have already been exported or will show up in the next export as reviews
  are completed.`;

export const INFO_AVERAGE_TIME_UNTIL_REVIEW_COMPLETED = `This elapsed time is
  the overall average elapsed time of every completed encounter review summed
  together and then divided by the number of completed reviews.`;

export const INFO_MAX_TIME_ENCOUNTER_REVIEW_INCOMPLETE = `This elapsed time is
  the maximum value for an encounter review being incomplete.`;

export const INFO_MAX_TIME_LINE_ITEM_UNWORKED = `This elapsed time is the
  maximum value for a line item on an encounter review to have the "unworked"
  status.`;

export const INFO_COUNT_OF_LINE_ITEMS_REJECTED = `This number is a count of all
  line items that have been rejected for all completed encounter reviews.`;

export const INFO_ESTIMATED_IMPACT_OF_REJECTED_LINE_ITEMS = `This dollar value
  is an estimation of the sum of dollars associated to each rejected line item
  on every completed encounter review.`;
